module.exports = __webpack_public_path__ + "img/logo_hover.b2aa4bcb.png";